class SharedService {
    constructor() {
      this.imageURL = 'https://ayumanagerpro.s3.ap-south-1.amazonaws.com/ayuraushadh/';
    }
  
    isLoggedIn() {
      const token = localStorage.getItem('token');
      return token !== null && token !== '';
    }
  
    isUserLoggedIn() {
      return JSON.parse(localStorage.getItem('isLoggedIn') || 'false');
    }
  
    // Set login details and store the token in localStorage
    setLoginDetails(response) {
      const data = response.data || {};
      const seller = data.seller || {};
  
      const name = seller.name || '';
      const email = seller.email || '';
      const token = data.token || '';
      const id = seller.id !== undefined ? seller.id : -1;
  
      localStorage.setItem('name', name);
      localStorage.setItem('email', email);
      localStorage.setItem('token', token);
      localStorage.setItem('id', id.toString());
    }
  
    // Get user data from localStorage
    getUserData() {
      const name = localStorage.getItem('name') || '';
      const email = localStorage.getItem('email') || '';
      const token = localStorage.getItem('token') || '';
      const id = parseInt(localStorage.getItem('id')) || -1;
  
      return {
        name,
        nameInitial: name ? name.trim().charAt(0).toUpperCase() : '',
        email,
        token,
        id,
      };
    }
  
    // Clear user data during logout
    logout() {
      localStorage.removeItem('name');
      localStorage.removeItem('email');
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      localStorage.removeItem('isLoggedIn');
    }
  
    // Get the stored token
    getToken() {
      return localStorage.getItem('token');
    }
  
    // Construct the full image URL
    getImageURL(image) {
      return `${this.imageURL}${image}`;
    }
  }
  
  export default new SharedService();
  